import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import CircledIcon from '../../../components/CircledIcon';
import useMobile from '../../../hooks/useMobileHook';
import GenericTable from '../../../components/GenericTable';
import { formatPrice } from '../../../utils/utils';
import CalloutCard from '../../../components/CalloutCard';
import IconButton from '../../../components/IconButton';
import { useState } from 'react';
import DefaultCard from '../../../components/DefaultCard';
import Button from '../../../components/Button';
import { getSpendingAccountsDescription, getSpendingAccountsDescriptionTitles } from './info/SpendingAccountsInfo';
import Link from '../../../components/Link';

export type customSpendingAccountsTabProps = {
  spendingAccounts: any;
  headerTitle?: String;
};

const SpendingAccountsTab = ({
  spendingAccounts,
  headerTitle,
}: customSpendingAccountsTabProps) => {

  const isMobile = useMobile();
  const [showDetails, setShowDetails] = useState<any>({
    healthcare: false,
    dependantcare: false,
  });

  const toggleDetails = (type: String) => {
    let key = type.replace('-', '');
    let value = showDetails[`${key}`];
    setShowDetails({...showDetails, [key]: !value});
  };

  const [tellMeMore, setTellMeMore] = useState<{[key: string]: boolean}>({
    healthcare: false,
    dependantcare: false,
  });

  const handleTellMeMore = (type: String) => {
    let key = type.replace('-', '');
    let value = tellMeMore[`${key}`];
    setTellMeMore({...tellMeMore, [key]: !value});
  };

  const getTableData = (plan: any) => {
    return {
      headers: ['Options', 'Annual Contribution Amount', 'Per Pay Period Contribution'],
      rows: [
        [
          'Contribution',
          formatPrice(plan['cost']*12),
          formatPrice(plan['cost']),
        ],
        [
          'No Coverage',
          formatPrice(0),
          formatPrice(0),
        ]
      ]
    };
  }

  const getSelectedRow = (benefit: any) => {
    return benefit['plan'].id === 'hca-noCoverage' || benefit['plan'].id === 'sac-noCoverage' ? 1 : 0;
  }

  const icon = (iconName: IconProp) => (
    <CircledIcon
      variant={'icon-emphasized'}
      size={isMobile ? 'icon-sm' : 'icon-lg'}
      icon={iconName}
    />
  );

  const getCardIcon = (type: String) => {
    switch (type) {
      case 'bed-pulse':
        return light('bed-pulse');
      case 'family':
        return light('family');
      default:
        return light('bed-pulse');
    }
  };

  return (
    <Container className={'px-0'}>
      <Row className={`align-items-center ${headerTitle ? 'mt-8' : ''}`}>
        <Col className={'col-12 col-lg-6'}>
          {headerTitle && <span className={'text-sm-16-lg-24 fw-normal lx-xxs'}>
            {headerTitle}
          </span>}
        </Col>
        <div>
          {spendingAccounts.map((benefit: any, index: number) => {
            return (
              <Container className={`m-0 ${index || headerTitle ? 'mt-10' : ''} p-10 border border-info rounded-1`}>
                <div className={'d-flex justify-content-between align-items-center mb-10'}>
                  <Col>
                    {icon(getCardIcon(benefit['generic'].icon))}
                    <span className={'h5 mb-0 ms-4'}>{benefit['generic'].title}</span>
                  </Col>
                  <div onClick={() => toggleDetails(benefit['type'])} className={'icon-button-wrapper'}>
                    <IconButton
                      variant="icon-default"
                      icon={light('circle-exclamation')}
                      extLabel="Benefit Info"
                    />
                  </div>
                </div>
                <Row className={`expandable-wrapper ${showDetails[benefit['type'].replace('-', '')] ? 'open' : ''}`}>
                  <div className="d-flex justify-content-center">
                    <DefaultCard
                      closeButton={
                        <Link 
                          className='pt-0' 
                          isAlignAtEnd 
                          isWhiteIcon 
                          rightIcon={light('close')}
                          onClick={() => toggleDetails(benefit['type'])}
                        />                      
                      }
                      variant="blue-motif"
                      leftHeading={
                        getSpendingAccountsDescriptionTitles(benefit['type'])
                      }
                      leftSubheading={
                        getSpendingAccountsDescription(benefit['type'], tellMeMore[`${benefit['type'].replace('-', '')}`])
                      }
                      button={
                        <Button
                          onClick={() => handleTellMeMore(benefit['type'].replace('-', ''))}
                          variant="primary-shadow"
                          size="sm"
                        >
                          {tellMeMore[`${benefit['type'].replace('-', '')}`] ? 'Tell me less' : 'Tell me more'}
                        </Button>
                      }
                      className={'mb-12'}
                    />
                  </div>
                </Row>
                <CalloutCard>
                  <Row className='col-12 col-lg-5 justify-content-between'>
                    <Col className='p-0 col-8 col-lg-12 text-start'>
                      <b>Minimum Contribution</b>
                    </Col>
                    <div className='p-0 col-4 col-lg-12 text-end text-lg-start'>
                      $120.00
                    </div>
                  </Row>
                  <Row className='col-12 col-lg-3 justify-content-between'>
                    <Col className='p-0 col-8 col-lg-12 text-start'>
                      <b>Maximum Contribution</b>
                    </Col>
                    <div className='p-0 col-4 col-lg-12 text-end text-lg-start'>
                      $5,000.00
                    </div>
                  </Row>
                  <Row className='col-12 col-lg-4 justify-content-between pe-lg-10'>
                    <Col className='p-0 col-4 col-lg-12 text-start text-lg-end'>
                      <b>Increments of</b>
                    </Col>
                    <div className='p-0 col-4 col-lg-12 text-end'>{formatPrice(1)}</div>
                  </Row>
                </CalloutCard>
                <Col className={'mt-10 overflow-auto'}>
                  <GenericTable
                    selectedRowIndex={getSelectedRow(benefit)}
                    tableData={getTableData(benefit['plan'])}
                  />
                </Col>          
              </Container>
            );
          })}
        </div>
      </Row>
    </Container>
  );
};

export default SpendingAccountsTab;
